<template>
    <div class="text-end">{{ textvalue }}</div>
</template>
<script setup lang="ts">
import { formatByteSize } from '@/utilities/utils';
import { ref } from 'vue';

/**
 * Gets a numeric value and convert it to bytes kb, mb, gb, tb with two decimal places
 */

const props = defineProps<{
    /**
     * The size to display
     * This is the size in bytes
     */
    value: number | null;
}>();

const textvalue = ref<string>(props.value === null ? '' : formatByteSize(props.value!));
</script>
